import React, { useState } from 'react';
import { useParams, useLocation, useHistory } from "react-router-dom";
import axios from 'axios';
import "pages/style.css"

export function EditInspector() {
    let history = useHistory();
    let { ID } = useParams();
    const location = useLocation();
    const { lastname, name, surname } = location.state
    const [formValue, setformValue] = useState({
        id: ID,
        name: name,
        surname: surname,
        lastname: lastname
    });
    const url = "/api/update/inspector"
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            axios.post(url, { id: parseInt(ID), name: formValue.name, surname: formValue.surname, lastname: formValue.lastname })
        } catch (error) {
            console.log(error)
        }
        history.go(-2)
    }
    const handleChange = (event) => {
        setformValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    }

    return (
        <div className='main'>
            <h2>Изменить ФИО инспектора</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Имя:
                    <br />
                    <input type="text" name="name" value={formValue.name} onChange={handleChange}></input>
                    <br />
                    Фамилия:
                    <br />
                    <input type="text" name="lastname" value={formValue.lastname} onChange={handleChange}></input>
                    <br />
                    Отчество:
                    <br />
                    <input type="text" name="surname" value={formValue.surname} onChange={handleChange}></input>
                    <br />
                </label>
                <br />
                <input type={"submit"} value={"Отправить"} />
                <input type={"button"} value={"Отменить"} onClick={() => {history.go(-2)}} />
            </form>
        </div>
    )
}